import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as SVGBackButton } from '@weezevent/throne/dist/images/back_arrow.svg';
import { ListNavigationBack } from '@weezevent/throne';

export function SeatMapBackButton({ name, onBack = () => {} }) {
    return (
        <React.Fragment>
            <ListNavigationBack onClick={onBack}>
                <SVGBackButton />
            </ListNavigationBack>
            <span className="availability-zone-name">{name}</span>
        </React.Fragment>
    );
}

SeatMapBackButton.propTypes = {
    name: PropTypes.string.isRequired,
    onBack: PropTypes.func
};
